import { Injectable } from '@angular/core';
import { core, isArray } from '@icc/shared/helpers/b2b';
import { GroupingSchema } from '../models/grouping-schema.model';
import {
    DocumentPositionGroup,
    DocumentPositionGroupSchema,
} from '../models/position-group.model';
import { generateKeyBetween } from 'fractional-indexing';
import { SalesDocument } from '../models/sales-document.model';
import { SalesDocumentPosition } from '../models/sales-document-position.model';
import { IccDocument } from '../models/icc-document';
import { IccDocumentPosition } from '../models/icc-document-position';

export class GroupingService {
    static groupPositionsBySchema(
        schema: GroupingSchema,
        document: IccDocument,
        positions: IccDocumentPosition[],
        existingGroups: DocumentPositionGroup[] = null
    ) {
        const groups: DocumentPositionGroup[] = [];
        const groupsMap: Map<string, DocumentPositionGroup> = new Map();
        for (const position of positions) {
            const groupKey = schema.match(position, document);
            if (groupKey) {
                let group = groupsMap.get(groupKey);
                const oldGroup = existingGroups?.find((g) => g.key === groupKey);
                if (!group) {
                    group = {
                        uuid: oldGroup?.uuid ?? core.generateUUID(),
                        key: groupKey,
                        positionIds: [],
                        positionOrder: {},
                        name: schema.getName?.(position, document) ?? groupKey,
                    };
                    groups.push(group);
                    groupsMap.set(groupKey, group)
                }
                group.positionIds.push(position.uuid);
                const latestKey = Object.values(group.positionOrder).sort().reverse()[0] ?? null;
                group.positionOrder[position.uuid] =
                    oldGroup?.positionOrder[position.uuid] ?? generateKeyBetween(latestKey, null);
            }
        }

        return groups;
    }

    static grouping(
        schemas: GroupingSchema[],
        document: IccDocument,
        positions: IccDocumentPosition[]
    ) {
        const groupSchemas: DocumentPositionGroupSchema[] = [];
        for (const schema of schemas) {
            const groupSchema = isArray(document?.groups) ? document.groups?.find((g) => g.groupSchemaId === schema.id) : null;
            const groups = GroupingService.groupPositionsBySchema(
                schema,
                document,
                positions,
                groupSchema?.groups
            );
            if (groups.length > 0) {
                groupSchemas.push({
                    groupSchemaId: schema.id,
                    groups,
                });
            }
        }
        return groupSchemas;
    }
}
